const BASE_URL = 'https://api.olaitools.com/api';
// Matches the six enums in the alerts table CHECK constraint
export const ALERT_CATEGORIES = [
    'never_attended',
    'missing_assignments',
    'low_engagement',
    'exam_performance',
    'satisfactory',
    'exceptional',
];

// GET /api/alerts/:canvasCourseId
// Returns { alerts: [...], source_key: string }
export const fetchAlerts = async (courseId) => {
    console.log("overviewApi - fetchAlerts - courseId:", courseId);
    const res = await fetch(`${BASE_URL}/alerts/${courseId}`, {
        credentials: 'include',
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Failed to fetch alerts");
    }
    return res.json(); // { alerts: [...], source_key: string }
};

// POST /api/alerts/:canvasCourseId/override  (backend route still pending)
// Body: { canvasUserId, category, notes? }
export const postAlertOverride = async (courseId, canvasUserId, category, notes = '') => {
    console.log("alertsApi - postAlertOverride - courseId, canvasUserId, category, notes:", courseId, canvasUserId, category, notes);
    const res = await fetch(`${BASE_URL}/alerts/${courseId}/override`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ canvasUserId, category, notes }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Failed to post alert override");
    }
    return res.json(); // { success: true }
};

export const triggerChiron = async (courseId) => {
    console.log("alertsApi - triggerChiron - courseId:", courseId);
    const res = await fetch(`${BASE_URL}/chiron/run`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ canvasCourseId: courseId }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Failed to trigger Chiron");
    }
    return res.json(); // { success: true, message: string }
};

export const fetchChironRun = async (courseId) => {
    console.log("alertsApi - fetchChironRun - courseId:", courseId);
    const res = await fetch(`${BASE_URL}/chiron/runs?canvasCourseId=${courseId}`, {
        credentials: 'include',
    });
    if (!res.ok) return null;  // no runs yet, treat as null not an error
    return res.json();
};

// GET /api/alerts/:canvasCourseId/notes/:canvasUserId
// Returns { notes: [{ id, note, created_at }, ...] }
export const fetchStudentNotes = async (courseId, canvasUserId) => {
    console.log("alertsApi - fetchStudentNotes - courseId, canvasUserId:", courseId, canvasUserId);
    const res = await fetch(`${BASE_URL}/alerts/${courseId}/notes/${canvasUserId}`, {
        credentials: 'include',
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Failed to fetch student notes");
    }
    return res.json();
};

// POST /api/alerts/:canvasCourseId/notes
// Body: { canvasUserId, note }
export const postStudentNote = async (courseId, canvasUserId, note) => {
    console.log("alertsApi - postStudentNote - courseId, canvasUserId, note:", courseId, canvasUserId, note);
    const res = await fetch(`${BASE_URL}/alerts/${courseId}/notes`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ canvasUserId, note }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Failed to post student note");
    }
    return res.json();
};